import React from 'react';
import { useFormik } from "formik";
import * as yup from "yup";
import { useAuth } from "../../provider/authProvider";
import { useNavigate } from 'react-router-dom';
import { useSignalRContext } from "../../SignalR/useSignalR";
import { Register } from "../../api/auth";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import './index.css';

const RegisterPage = () => {
  const navigate = useNavigate();
  const { setToken } = useAuth();
  const { connect } = useSignalRContext();
  const validation = yup.object({
    email: yup.string().email("Enter a valid email").required("Email is required"),
    firstName: yup.string().required("First Name is required"),
    lastName: yup.string().required("Last Name is required"),
    password: yup.string().min(6, "Password should have a minimum of 6 characters").required("Password is required"),
    confirmPassword: yup.string().min(6, "Password should have a minimum of 6 characters").required("Password is required").oneOf([yup.ref('password'), null], "Passwords must be same"),
  });
  const { handleSubmit, handleChange, handleBlur, values, touched, errors } = useFormik({
    initialValues: { email: '', firstName: '', lastName: '', password: '', confirmPassword: '' },
    validationSchema: validation,
    onSubmit: async (values) => {
      const { status, error, message } = await Register(values.email, values.firstName, values.lastName, values.password, values.confirmPassword);
      if (error) {
        toast.error(error);
      } else {
        toast.success(message);
        navigate("/", { replace: true });
      }
    },
  });
  return (
    <div className="auth-root">
      <ToastContainer position='top-right' autoClose={5000} theme='dark' />
      <div className="auth-left">
        <form className="auth-form" onSubmit={handleSubmit}>
          <h2 className="auth-title">Sign up</h2>
          <label className="auth-label" htmlFor="firstName">First Name <span>*</span></label>
          <input
            className="auth-input"
            id="firstName"
            name="firstName"
            type="text"
            value={values.firstName}
            onChange={handleChange}
            onBlur={handleBlur}
            autoComplete="given-name"
          />
          {touched.firstName && errors.firstName && <div className="auth-error">{errors.firstName}</div>}
          <label className="auth-label" htmlFor="lastName">Last Name <span>*</span></label>
          <input
            className="auth-input"
            id="lastName"
            name="lastName"
            type="text"
            value={values.lastName}
            onChange={handleChange}
            onBlur={handleBlur}
            autoComplete="family-name"
          />
          {touched.lastName && errors.lastName && <div className="auth-error">{errors.lastName}</div>}
          <label className="auth-label" htmlFor="email">Email <span>*</span></label>
          <input
            className="auth-input"
            id="email"
            name="email"
            type="email"
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
            autoComplete="email"
          />
          {touched.email && errors.email && <div className="auth-error">{errors.email}</div>}
          <label className="auth-label" htmlFor="password">Password <span>*</span></label>
          <input
            className="auth-input"
            id="password"
            name="password"
            type="password"
            value={values.password}
            onChange={handleChange}
            onBlur={handleBlur}
            autoComplete="new-password"
          />
          {touched.password && errors.password && <div className="auth-error">{errors.password}</div>}
          <label className="auth-label" htmlFor="confirmPassword">Confirm Password <span>*</span></label>
          <input
            className="auth-input"
            id="confirmPassword"
            name="confirmPassword"
            type="password"
            value={values.confirmPassword}
            onChange={handleChange}
            onBlur={handleBlur}
            autoComplete="new-password"
          />
          {touched.confirmPassword && errors.confirmPassword && <div className="auth-error">{errors.confirmPassword}</div>}
          <button className="auth-btn" type="submit">Sign up</button>
          <button type="button" className="google-btn" style={{marginTop:16, background:'#4285F4', color:'#fff', border:'none', borderRadius:4, padding:0, fontWeight:500, display:'flex', alignItems:'center', justifyContent:'center', height:40, width:'100%', fontSize:16, cursor:'pointer', boxShadow:'0 1px 2px rgba(60,64,67,.3)'}}>
            <span style={{background:'#fff', height:40, width:40, display:'flex', alignItems:'center', justifyContent:'center', borderTopLeftRadius:4, borderBottomLeftRadius:4, marginRight:12}}>
              <svg width="18" height="18" viewBox="0 0 18 18"><g><path d="M9 3.48c1.69 0 2.83.73 3.48 1.34l2.56-2.5C13.73.89 11.7 0 9 0 5.48 0 2.44 2.24 1 5.5l3.04 2.36C4.88 5.36 6.75 3.48 9 3.48z" fill="#EA4335"/><path d="M17.64 9.2c0-.63-.06-1.25-.16-1.84H9v3.48h4.84c-.21 1.13-.84 2.09-1.8 2.73l2.82 2.2c1.65-1.53 2.6-3.78 2.6-6.57z" fill="#4285F4"/><path d="M3.91 10.96A5.41 5.41 0 0 1 3.5 9c0-.68.12-1.34.32-1.96L.78 4.62A8.97 8.97 0 0 0 0 9c0 1.41.34 2.75.94 3.93l2.97-2.97z" fill="#FBBC05"/><path d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.82-2.2c-.78.52-1.78.83-3.14.83-2.25 0-4.12-1.88-4.79-4.39l-3.04 2.36C2.44 15.76 5.48 18 9 18z" fill="#34A853"/></g></svg>
            </span>
            <span style={{flex:1, textAlign:'center'}}>Sign in with Google</span>
          </button>
          <div className="auth-link-row">
            <span>Already have an account?</span>
            <button type="button" className="auth-link" onClick={() => navigate('/login')}>Sign in</button>
          </div>
        </form>
      </div>
      <div className="auth-right">
        <div className="auth-logo-row">
          <span className="rocket-emoji">🚀</span>
          <span className="auth-logo-text">quantfix</span>
        </div>
        <div className="auth-marketing">
          <h1 className="auth-marketing-title">Bring trading to <span className="auth-gradient">life</span></h1>
          <div className="auth-hashtag">#withQTradeView</div>
          <div className="auth-marketing-desc">
            From market analysis and algorithmic strategies to execution and portfolio management, build and automate anything in one powerful professional platform.
          </div>
          <div className="auth-marketing-trust">Trusted by 500,000+ Traders &nbsp; | &nbsp; Ultra-low latency</div>
        </div>
      </div>
    </div>
  );
};
export default RegisterPage;